export default "__VITE_ASSET__B_g9n0Cx__"